import MaterialCategory from './MaterialCategory';
import BusinessCard from './BusinessCard';
import store from '@/store';

interface IMaterialItem {
    id?: number;
    categoryId?: number;
    listItem?: string;
    outOfStock?: boolean;
    quantityOfStock?: number;
    displayOnMaintenance?: boolean;
    created?: Date;
    createdById?: number;
    updated?: Date;
    updatedById?: number;
    canBeDeleted?: boolean;
    active?: boolean;
    isBusinessCardItem?: boolean;
    businessCard?: BusinessCard;
    addedToForm?: boolean;
}

class MaterialItem implements IMaterialItem {
    public id?: number;
    public categoryId?: number;
    public categoryName?: string;
    public listItem?: string;
    public outOfStock?: boolean;
    public quantityOfStock?: number;
    public displayOnMaintenance?: boolean = false;
    public created?: Date;
    public createdById?: number;
    public updated?: Date;
    public updatedById?: number;
    public canBeDeleted?: boolean;
    public active?: boolean;
    public isBusinessCardItem?: boolean;
    public businessCard?: BusinessCard;
    public addedToForm?: boolean;
    public formQuantity?: number; // Used in MaterialForm input

    constructor(m: IMaterialItem = {}) {
        this.id = m.id;
        this.categoryId = m.categoryId;
        this.categoryName = this.setCategoryName();
        this.listItem = m.listItem;
        this.outOfStock = m.outOfStock;
        this.quantityOfStock = m.quantityOfStock;
        this.displayOnMaintenance = m.displayOnMaintenance;
        this.created = m.created ? new Date(m.created) : undefined;
        this.createdById = m.createdById;
        this.updated = m.updated ? new Date(m.updated) : undefined;
        this.updatedById = m.updatedById;
        this.canBeDeleted = m.canBeDeleted;
        this.active = m.active;
        this.isBusinessCardItem = this.setIsBusinessCardItem();
        this.businessCard = m.businessCard !== undefined ?
            m.businessCard : this.isBusinessCardItem ? new BusinessCard() : undefined;
        this.addedToForm = m.addedToForm;
    }

    public setCategoryName(): string {
        if (this.categoryId) {
            const category: MaterialCategory = store.getters['material/getCategoryById'](this.categoryId);
            return category.category ? category.category : '';
        } else {
            return '';
        }
    }

    public setIsBusinessCardItem(): boolean {
        if (this.categoryId) {
            const category: MaterialCategory = store.getters['material/getCategoryById'](this.categoryId);
            return category.isBusinessCard !== undefined ? category.isBusinessCard : false;
        } else {
            return false;
        }
    }

    public setAddedToForm(bool: boolean): void {
        this.addedToForm = bool;
    }
}

export default MaterialItem;
export { MaterialItem, IMaterialItem };
